import * as env from "../env.json";
import {UNAUTHORIZED, FILE_TOO_LARGE } from './errormessages'

let baseHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Origin: "*",
};

export async function apiCall(
  api,
  method,
  auth = {},
  body = null,
  withBase = null,
  headers = null,
  attempt = 0,
  isBlob = false
) {
  return new Promise(async (resolve, reject) => {
    let baseAPI = "";
    let requestHeaders = {};
    if (withBase) {
      baseAPI = withBase;
    } else {
      baseAPI = env.baseURL;
    }
    if (headers) {
      requestHeaders = { ...headers, ...auth };
    } else {
      requestHeaders = { ...baseHeaders, ...auth };
    }
    fetch(baseAPI + api, { method, headers: requestHeaders, body })
      .then(async (res) => {
        try {
          if (!res.ok && res.status === 413) {
            return Promise.reject({
              UserFriendlyErrorCode: FILE_TOO_LARGE,
              ErrorCode: "ServerError",
            });
          }
          if (!res.ok && res.status === 401) {
            console.log('Unauthorized:', res);
            return Promise.reject({
              UserFriendlyErrorCode: UNAUTHORIZED,
              ErrorCode: "Unauthorized",
            });
          }
          if (isBlob && res.ok) {
            return res.blob();
          }
          if (
            res.ok &&
            res.headers.get("Content-Type") == null &&
            res.headers.get("Content-Length") == 0
          ) {
            return { success: true };
          }
          return res.json().then((json) => {
            return res.ok
              ? json
              : Promise.reject(
                  json.ErrorCode ? json : { ...json, ErrorCode: "ServerError" }
                );
          });
        } catch (e) {
          console.log('API Call Error:', e);
          return res.text().then((text) => {
            return res.ok ? text : Promise.reject(text);
          });
        }
      })
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

